<div class="shell" #drawerOrigin="rtOverlayOrigin" rt-overlay-origin>
  @if (expanded()) {
    <tellent-assistant-thread-drawer
      class="drawer drawer-inline"
      [threads]="threadsFacade.threads()"
      [activeId]="facade.currentThreadId()"
      [isDeleting]="isDeleting"
      [showBack]="false"
      (newThread)="newThread()"
      (selectThread)="selectThread($event)"
      (deleteThread)="deleteThread($event)"
      (helpCenter)="openHelpCenter()"
      (intelligenceSettings)="openIntelligenceSettings()"
    />
  }

  <section class="main">
    <tellent-assistant-header
      [title]="title()"
      [inThread]="facade.messages().length > 0"
      [expanded]="expanded()"
      (menu)="drawerOpen.set(!drawerOpen())"
      (newChat)="newThread()"
      (close)="close.emit()"
      (expand)="expand.emit()"
      (collapse)="collapse.emit()"
    />

    <div class="body">
      @if (facade.messages().length === 0) {
        <tellent-assistant-empty-state
          [userName]="config.userName()"
          [suggestions]="config.suggestions()"
          [loading]="false"
          [expanded]="expanded()"
          (suggestionClick)="send($event)"
        />
      } @else {
        <div class="messages">
          @for (msg of facade.messages(); track msg.id) {
            <tellent-assistant-message [message]="msg" />
          }
          @if (facade.runStatus() === 'running') {
            <tellent-assistant-thinking-indicator />
          }
        </div>
      }
    </div>

    <tellent-assistant-input
      [busy]="facade.runStatus() === 'running'"
      (send)="send($event)"
      (stop)="facade.cancelRun()"
    />

    <p class="disclaimer">
      {{ 'tlc.tellent_assistant.chat_panel.disclaimer_text' | translate }}
      <a href="https://support.tellent.com/ai" target="_blank" rel="noopener">
        {{ 'tlc.tellent_assistant.chat_panel.disclaimer_link' | translate }}
      </a>
    </p>
  </section>

  @if (!expanded()) {
    <ng-template
      #drawerOverlay="rtConnectedOverlay"
      rt-connected-overlay
      [origin]="drawerOrigin"
      [positions]="drawerPositions"
      [offsetX]="-21"
      [offsetY]="-17"
      [rtConnectedOverlayAutoClose]="false"
      [hasBackdrop]="false"
      [open]="drawerOpen()"
      (attach)="onDrawerAttach()"
    >
      <tellent-assistant-thread-drawer
        class="drawer"
        [threads]="threadsFacade.threads()"
        [activeId]="facade.currentThreadId()"
        [isDeleting]="isDeleting"
        (back)="drawerOpen.set(false)"
        (newThread)="newThread(); drawerOpen.set(false)"
        (selectThread)="selectThread($event); drawerOpen.set(false)"
        (deleteThread)="deleteThread($event)"
        (helpCenter)="openHelpCenter()"
        (intelligenceSettings)="openIntelligenceSettings()"
      />
    </ng-template>
  }
</div>
